module.exports = __webpack_public_path__ + "static/media/warning.ab998c60.svg";